/**
 * Объявление Авито, по которому пишет клиент, — полоской под шапкой чата, как закреп в Telegram:
 * фото, заголовок, цена, ссылка на Авито и «Похожие» — поиск платья по фото объявления
 * (`POST /api/chats/{id}/dress-search` без сообщения). Messenger API отдаёт одно фото 140×105.
 */
import { useQuery } from "@tanstack/react-query";
import { ExternalLink, ScanSearch } from "lucide-react";
import { useState } from "react";

import { chatItem } from "@/lib/clientChats";

export function AvitoItem({ chatId, onSimilar }: { chatId: number; onSimilar: () => void }) {
  const q = useQuery({ queryKey: ["chat-item", chatId], queryFn: () => chatItem(chatId), staleTime: Infinity, retry: false });
  const [broken, setBroken] = useState(false);
  const item = q.data;
  if (!item?.title) return null;
  const photo = item.image && !broken;
  return (
    <div className="flex items-center gap-2.5 px-3 pt-1.5" data-annot="объявление Авито">
      {photo && (
        <a href={item.url || undefined} target="_blank" rel="noreferrer" className="flex-none" title="Открыть объявление на Авито">
          <img
            src={`/api/chats/${chatId}/item/photo`}
            alt="Фото объявления"
            onError={() => setBroken(true)}
            className="h-10 w-[54px] rounded-[6px] bg-black/10 object-cover"
          />
        </a>
      )}
      <div className="min-w-0 flex-1 text-[13px] leading-tight">
        {item.url ? (
          <a href={item.url} target="_blank" rel="noreferrer" className="block truncate font-medium text-[var(--tg-text)] hover:underline" title={item.title}>
            {item.title}
          </a>
        ) : (
          <div className="truncate font-medium text-[var(--tg-text)]">{item.title}</div>
        )}
        <div className="truncate text-[var(--tg-sec)]">{[item.price, item.city].filter(Boolean).join(" · ") || "Авито"}</div>
      </div>
      {photo && (
        <button
          type="button"
          onClick={onSimilar}
          title="Найти в салонах платья, похожие на фото объявления"
          className="flex h-8 flex-none cursor-pointer items-center gap-1.5 rounded-full bg-[var(--tg-input)] px-3 text-[13px] font-medium text-[var(--tg-text)] hover:bg-[var(--tg-hover)]"
        >
          <ScanSearch size={15} /> Похожие
        </button>
      )}
      {item.url && (
        <a
          href={item.url}
          target="_blank"
          rel="noreferrer"
          title="Открыть объявление на Авито"
          className="grid size-8 flex-none place-items-center rounded-full text-[var(--tg-sec)] hover:bg-[var(--tg-hover)]"
        >
          <ExternalLink size={16} />
        </a>
      )}
    </div>
  );
}
